<template>
  <div>
    <b-row :class="$route.name == 'UpdatePassword' ? 'mt-5' : ''">
      <b-col
        :cols="$route.name == 'UpdatePassword' ? '6' : '12'"
        :offset="$route.name == 'UpdatePassword' ? '3' : '0'"
      >
        <b-form-group>
          <b-row>
            <b-col cols="4">
              <label>
                Current Password
                <span class="required-span">*</span>
              </label>
            </b-col>
            <b-col cols="8">
              <b-form-input
                size="sm"
                v-model="$v.passwordForms.currentPassword.$model"
                :state="$v.passwordForms.currentPassword.$dirty ? !$v.passwordForms.currentPassword.$error : null"
                type="password"
                placeholder="Enter Current Password"
              ></b-form-input>
              <b-form-invalid-feedback class="text-left">This field is required</b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group>
          <b-row>
            <b-col cols="4">
              <label>
                New Password
                <span class="required-span">*</span>
              </label>
            </b-col>
            <b-col cols="8">
              <b-form-input
                size="sm"
                v-model="$v.passwordForms.newPassword.$model"
                :state="$v.passwordForms.newPassword.$dirty ? !$v.passwordForms.newPassword.$error : null"
                type="password"
                placeholder="Enter New Password"
              ></b-form-input>
              <ul class="password-rules list-unstyled text-left">
                <li :class="{ 'rule-met': passwordRules.minLength }">
                  <span class="rule-icon">{{ passwordRules.minLength ? "✓" : "✗" }}</span>
                  Minimum 10 characters
                </li>
                <li :class="{ 'rule-met': passwordRules.upper }">
                  <span class="rule-icon">{{ passwordRules.upper ? "✓" : "✗" }}</span>
                  At least one uppercase letter
                </li>
                <li :class="{ 'rule-met': passwordRules.lower }">
                  <span class="rule-icon">{{ passwordRules.lower ? "✓" : "✗" }}</span>
                  At least one lowercase letter
                </li>
                <li :class="{ 'rule-met': passwordRules.digit }">
                  <span class="rule-icon">{{ passwordRules.digit ? "✓" : "✗" }}</span>
                  At least one number
                </li>
                <li :class="{ 'rule-met': passwordRules.special }">
                  <span class="rule-icon">{{ passwordRules.special ? "✓" : "✗" }}</span>
                  At least one special character
                </li>
              </ul>
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group>
          <b-row>
            <b-col cols="4">
              <label>
                Confirm Password
                <span class="required-span">*</span>
              </label>
            </b-col>
            <b-col cols="8">
              <b-form-input
                size="sm"
                v-model="$v.passwordForms.confirmNewPassword.$model"
                :state="$v.passwordForms.confirmNewPassword.$dirty ? !$v.passwordForms.confirmNewPassword.$error : null"
                type="password"
                placeholder="Enter Confirm Password"
              ></b-form-input>
              <b-form-invalid-feedback class="error text-left">Password and Confirm Password do not match.</b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-form-group>
        <b-row>
          <b-col cols="12">
            <b-button
              class="float-right"
              type="button"
              @click="onUpdatePassword"
              variant="primary"
            >{{$t('updateBtn')}}</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { HTTP } from "../../utils/HTTP";
import { validationMixin } from "vuelidate";
import { required, sameAs, minLength, helpers } from "vuelidate/lib/validators";
import { Helper } from "../../helpers";
import { withSessionChange } from "../../utils/auth-requests";

// Same strong-password policy as createPassword.vue (EB2-58207) — min 10
// characters, at least one uppercase, one lowercase, one digit, and one
// special character.
const hasUpperCase = helpers.regex( "hasUpperCase", /[A-Z]/ );
const hasLowerCase = helpers.regex( "hasLowerCase", /[a-z]/ );
const hasDigit = helpers.regex( "hasDigit", /[0-9]/ );
const hasSpecialChar = helpers.regex( "hasSpecialChar", /[^A-Za-z0-9]/ );
export default {
  name: "UpdatePassword",
  mixins: [validationMixin],
  data () {
    return {
      passwordForms: {
        currentPassword: null,
        newPassword: null,
        confirmNewPassword: null,
      },
      userDetail: null,
    };
  },
  validations: {
    passwordForms: {
      currentPassword: {
        required,
      },
      newPassword: {
        required,
        minLength: minLength( 10 ),
        hasUpperCase,
        hasLowerCase,
        hasDigit,
        hasSpecialChar,
      },
      confirmNewPassword: {
        required,
        sameAsPassword: sameAs( "newPassword" ),
      },
    },
  },
  computed: {
    passwordRules () {
      let pwd = this.passwordForms.newPassword || "";
      return {
        minLength: pwd.length >= 10,
        upper: /[A-Z]/.test( pwd ),
        lower: /[a-z]/.test( pwd ),
        digit: /[0-9]/.test( pwd ),
        special: /[^A-Za-z0-9]/.test( pwd ),
      };
    },
  },
  mounted () {
    // console.log(this.$route.name);
    this.setUserDetail();
  },
  methods: {
    setUserDetail () {
      let datail = JSON.parse( localStorage.getItem( "userDetail" ) );
      this.userDetail = datail;
    },
    makeUpdatePasswordToster ( tosterVarient, tosterMsg ) {
      let userType = localStorage.getItem( 'userType' );
      // On $root so the toast survives the redirect to the dashboard
      Helper.makeToast( this.$root.$bvToast, tosterVarient, tosterMsg );
      if ( tosterVarient == "success" ) {
        if ( this.$route.name == "UpdatePassword" ) {
          if ( userType == 3 ) {
            this.$router.push( "/dashboard" );
          } else if ( userType == 2 ) {
            this.$router.push( "/dashboard" );
          } else {
            this.$router.push( "/manage-employee" );
          }
        }
      }
    },
    onUpdatePassword () {
      this.$v.passwordForms.$touch();
      if ( this.$v.passwordForms.$anyError ) {
        return;
      } else {
        this.updatePasswordApiCall();
      }
    },
    async updatePasswordApiCall () {
      let formData = {
        userId: this.userDetail.id,
        currentPassword: this.passwordForms.currentPassword,
        newPassword: this.passwordForms.newPassword,
        user_id: localStorage.getItem( "userId" ),
      };
      try {
        // The response carries this device's new tokens, so no token refresh may overlap it
        let result = await withSessionChange( () => HTTP(
          "post",
          "api/v1/user/update/password",
          formData
        ) );
        // Other devices are logged out by the password change; this one gets a fresh token
        if ( result.data.accessToken ) {
          this.$store.commit( "SET_ACCESS_TOKEN", result.data.accessToken );
          localStorage.setItem( "accessToken", result.data.accessToken );
        }
        if ( result.data.status == 0 ) {
          this.makeUpdatePasswordToster( "warning", result.data.message );
        } else if ( result.data.status == 1 ) {
          this.makeUpdatePasswordToster( "warning", result.data.message );
        } else if ( result.data.status == 2 ) {
          this.makeUpdatePasswordToster( "danger", result.data.message );
        } else if ( result.data.status == 3 ) {
          this.makeUpdatePasswordToster( "warning", result.data.message );
        } else if ( result.data.status == 4 ) {
          this.makeUpdatePasswordToster( "success", result.data.message );
        }
        this.passwordForms = {
          currentPassword: null,
          newPassword: null,
          confirmNewPassword: null,
        };
        this.$v.$reset();
      } catch ( err ) {
        // Network/server failure (validation errors come back as HTTP 200 with a status)
        let apiMessage = err && err.response && err.response.data && err.response.data.message;
        this.makeUpdatePasswordToster( "warning", apiMessage || "Please Try Again Later" );
        return [err];
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
.password-rules {
  font-size: 0.85rem;
  color: #8a94a6;
  margin: 0.5rem 0 0;
  padding-left: 0;
  text-align: left;
}
.password-rules li {
  margin-bottom: 4px;
}
.password-rules .rule-icon {
  display: inline-block;
  width: 1.2em;
}
.password-rules li.rule-met {
  color: #2e7d4f;
}
</style>